import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FaWhatsapp } from "react-icons/fa";
import { TbPhoneCall } from "react-icons/tb";
import { FiMail } from "react-icons/fi";
import { FaRegEdit } from "react-icons/fa";
import { MdDeleteOutline } from "react-icons/md";
import ProductOwnedDetails from './SubComponents/ProductOwnedDetails';
import ProductDetails from './SubComponents/ProductDetails';
import ProductManagementDetails from './SubComponents/ProductManagementDetails';
import SelfLifeDetails from './SubComponents/SelfLifeDetails';
import FileAttachment from './SubComponents/FileAttachment';
import DescriptionAboutProducts from './SubComponents/DescriptionAboutProducts';
import { GetSingleProduct, UpdateAndDeleteProduct } from '../../../services/ProductService/AllProductList/AllProductServices';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import AddProduct from '../AddProducts/AddProduct';

const ViewProduct = () => {
    const { id } = useParams();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const mode = query.get('mode'); // 'view' or 'edit'
    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('ProductDetails');
    const [showConfirmPopup, setShowConfirmPopup] = useState(false);
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const [showAddProduct, setShowAddproduct] = useState(false);
    const navigate = useNavigate();

 console.log('Mode:',mode);
 
    const fetchProduct = async () => {
        setLoading(true);
        try {
            const response = await GetSingleProduct('GET', id, {}); // ✅ API call to fetch product by id
            setProduct(response.data);
        } catch (err) {
            setError('Failed to fetch product data');
        } finally {
            setLoading(false);
        }
    };

    const handleCloseViewProduct = () => {
        navigate(`/admin-dashboard/product-module/all-products`);
    }

    const handleEditProduct = () => {
        setShowAddproduct(true)
    }

    const handleDeleteSingleProduct = async (id) => {
            if (id) {
                try {
                    const response = await UpdateAndDeleteProduct('DELETE', id, {});
                    if (response) {
                        setShowConfirmPopup(false);
                        setShowSuccessPopup(true);
                        setTimeout(() => {
                            setShowSuccessPopup(false);
                                navigate(`/admin-dashboard/product-module/all-products`);
                        }, 1000);
                    }
                } catch (error) {
                    console.error('Failed to delete product:', error);
                }
            }
        };

    useEffect(() => {
        if (mode === 'view') {
            fetchProduct();
        }
    }, [id]);

    useEffect(() => {
         if (mode === 'edit'){
            fetchProduct()
            setShowAddproduct(true)
        }
    }, [id]);

    if (loading) {
        return <div>Loading product data...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div>
            {/* Home button */}
            <div className="flex items-center gap-5 text-md text-gray-500 cursor-pointer pb-5 px-8"
                    onClick={handleCloseViewProduct}><FontAwesomeIcon icon={faAngleLeft} />
                    <p>Home</p>
                </div>
                {showAddProduct ? (<AddProduct id={id}/>) : (
                    <div className='shadow-custom rounded-[20px] border '>
                    <div className='flex justify-between border-b border-gray-200 pb-2 px-[30px] py-[10px]'>
                        <div>
                            <h1 className='text-xl text-gray-400 font-semibold'>Product Details</h1>
                        </div>
    
                        {product ? (
                            <>
                                <div className='flex gap-[15px]'>
                                    <div className='flex gap-[5px] rounded-[5px] items-center px-3 py-1 bg-[#25D366] text-[#fff] font-semibold'>
                                        <FaWhatsapp />
                                        <button>Whatsapp</button>
                                    </div>
                                    <div className='flex gap-[5px] rounded-[5px] items-center px-3 py-1 bg-[#333333] text-[#fff] font-semibold'>
                                        <TbPhoneCall />
                                        <button>Call</button>
                                    </div>
                                    <div className='flex gap-[5px] rounded-[5px] items-center border border-[#0C92CC] text-[#0C92CC] font-semibold'>
                                        <div className='bg-[#0C92CC] px-2 py-2 text-[#fff]'>
                                            <FiMail />
                                        </div>
                                        <button className='px-2'>Send Mail</button>
                                    </div>
                                </div>
                                <div className='flex'>
                                    <button className="mr-2 bg-[#333333] p-1 px-2 rounded-[5px] text-[#fff] text-xl">
                                        <FaRegEdit onClick={handleEditProduct}/>
                                    </button>
                                    <button className="text-[#fff] px-2 py-1 bg-[#FF0000] text-xl rounded-[5px]">
                                        <MdDeleteOutline onClick={()=>setShowConfirmPopup(true)}/>
                                    </button>
                                </div>
                            </>
                        ) : null}
                    </div>
    
                    <div className='flex items-center justify-between py-3 px-6'>
                        <div className='flex items-center gap-5'>
                            <h1
                                onClick={() => setActiveTab('ProductDetails')}
                                className={`text-xl  font-semibold cursor-pointer 
                                ${activeTab === 'ProductDetails' ? 'text-[#FF0000]  underline decoration-[#FF0000]  underline-offset-4' : 'text-gray-500 hover:text-[#FF0000] '}
                            `}
                            >
                                Product Details
                            </h1>
                            <h1
                                onClick={() => setActiveTab('productOwner')}
                                className={`text-xl  font-semibold cursor-pointer 
                                ${activeTab === 'productOwner' ? 'text-[#FF0000]  underline decoration-[#FF0000]  underline-offset-4' : 'text-gray-500 hover:text-[#FF0000] '}
                            `}
                            >
                                Product Owner Details
                            </h1>
                        </div>
                        <div>
                            {product.active ? (
                                <span
                                    className="py-2 px-3 w-fit rounded-xl text-center flex items-center justify-center gap-2 text-[#38A06C] bg-[#ddfdee]"
                                >
                                    Active
                                </span>
                            ) : (
                                <span
                                    className=" py-2 px-3 w-fit rounded-xl text-[#D1293D] bg-[#ffdce0] text-center flex items-center justify-center gap-2"
                                >
                                    <p>Deactive</p>
                                </span>
                            )}
                        </div>
                    </div>
    
                    {product ? (
                        <div>
                            {activeTab === 'ProductDetails' ? (
                                <div>
                                    {/* <div className='shadow-custom mx-[30px] my-[20px] rounded-[15px]'>
                                <ProductOwnedDetails />
                            </div> */}
                                    <div className='shadow-custom mx-[30px] my-[20px] rounded-[15px]'>
                                        <ProductManagementDetails ProductData={product} />
                                    </div>
                                    <div className='shadow-custom mx-[30px] my-[20px] rounded-[15px]'>
                                        <ProductDetails ProductData={product} />
                                    </div>
                                    <div className='shadow-custom mx-[30px] my-[20px] rounded-[15px]'>
                                        <SelfLifeDetails ProductData={product} />
                                    </div>
                                    <div className='shadow-custom mx-[30px] my-[20px] rounded-[15px]'>
                                        <FileAttachment ProductData={product} />
                                    </div>
                                    <div className='shadow-custom mx-[30px] my-[20px] rounded-[15px]'>
                                        <DescriptionAboutProducts ProductData={product} />
                                    </div>
                                </div>
                            ) : activeTab === 'productOwner' ? (
                                <div>
                                    <div className='shadow-custom mx-[30px] my-[20px] rounded-[15px]'>
                                        <ProductOwnedDetails />
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    ) : (
                        <p>No product data available.</p>
                    )}
                </div>
                )}

            {/* Confirmation Popup */}
            {showConfirmPopup && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg">
                        <div className="text-center">
                            <div className="text-red-500 text-4xl mb-2">❓</div>
                            <p className="text-lg">Do you want to delete this Product?</p>
                        </div>
                        <div className="flex justify-center gap-4 mt-4">
                            <button
                                className="px-4 py-2 border border-red-500 text-red-500 rounded font-bold"
                                onClick={() => setShowConfirmPopup(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className="px-4 py-2 bg-red-600 text-white rounded font-bold"
                                onClick={()=>handleDeleteSingleProduct(id)}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {showSuccessPopup && (
                <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-green-500 text-white px-4 py-2 rounded-md shadow-md">
                    Product deleted successfully!
                </div>
            )}
        </div>
    );
};

export default ViewProduct;